import React from 'react';

const SalesDeck = ({ onGetQuote }) => {
  return (
    <div className="relative min-h-screen bg-gray-50">
      <div className="bg-white p-8 max-w-4xl mx-auto space-y-12">
        {/* Title Section */}
        <div id="overview" className="bg-gradient-to-r from-blue-600 to-blue-800 text-white p-12 rounded-lg text-center">
          <h1 className="text-4xl font-bold mb-4">AWS Managed Services</h1>
          <h2 className="text-2xl mb-8">For Logistics & Warehouse Management</h2>
          <div className="flex justify-center space-x-8">
          </div>
        </div>
        {/* Market Challenges Section */}
        <div id="challenges" className="bg-white shadow-lg rounded-lg p-8">
          <h2 className="text-2xl font-bold mb-6 text-gray-800">Australian Logistics Market Challenges</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-red-100 rounded-full flex items-center justify-center">
                  <div className="w-4 h-4 bg-red-500 rounded-full" />
                </div>
                <div>
                  <h3 className="font-semibold">System Reliability</h3>
                  <p className="text-sm text-gray-600">Downtime costs up to $15,000 per hour</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-orange-100 rounded-full flex items-center justify-center">
                  <div className="w-4 h-4 bg-orange-500 rounded-full" />
                </div>
                <div>
                  <h3 className="font-semibold">IT Skills Shortage</h3>
                  <p className="text-sm text-gray-600">Limited AWS expertise in market</p>
                </div>
              </div>
            </div>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-yellow-100 rounded-full flex items-center justify-center">
                  <div className="w-4 h-4 bg-yellow-500 rounded-full" />
                </div>
                <div>
                  <h3 className="font-semibold">Compliance Requirements</h3>
                  <p className="text-sm text-gray-600">Complex regulatory landscape</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <div className="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center">
                  <div className="w-4 h-4 bg-green-500 rounded-full" />
                </div>
                <div>
                  <h3 className="font-semibold">Cost Management</h3>
                  <p className="text-sm text-gray-600">Unpredictable IT expenses</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Infrastructure Section */}
        <div id="infrastructure" className="bg-white shadow-lg rounded-lg p-8">
          <h2 className="text-2xl font-bold mb-6 text-gray-800">AWS Infrastructure for Logistics</h2>
          <div className="bg-blue-50 p-6 rounded-lg">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0 md:space-x-4">
              <div className="w-full md:w-1/4 bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
                <h3 className="font-semibold text-center">WMS Layer</h3>
                <p className="text-sm text-gray-600 text-center mt-2">Application Hosting</p>
              </div>
              <div className="w-full md:w-1/4 bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
                <h3 className="font-semibold text-center">Integration Layer</h3>
                <p className="text-sm text-gray-600 text-center mt-2">API Management</p>
              </div>
              <div className="w-full md:w-1/4 bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow">
                <h3 className="font-semibold text-center">Data Layer</h3>
                <p className="text-sm text-gray-600 text-center mt-2">Storage & Processing</p>
              </div>
            </div>
            <div className="my-6 border-t border-blue-200" />
            <div className="text-center text-sm text-blue-800 font-medium">
              Managed Security | Monitoring | Backup | Compliance
            </div>
          </div>
        </div>

        {/* Benefits Section */}
        <div id="benefits" className="bg-white shadow-lg rounded-lg p-8">
          <h2 className="text-2xl font-bold mb-6 text-gray-800">Managed Service Benefits</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-green-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
              <h3 className="font-semibold text-green-800 mb-4">Operational Benefits</h3>
              <ul className="space-y-3">
                <li className="flex items-center">
                  <div className="w-4 h-4 bg-green-500 rounded-full mr-2" />
                  <span>99.99% System Uptime</span>
                </li>
                <li className="flex items-center">
                  <div className="w-4 h-4 bg-green-500 rounded-full mr-2" />
                  <span>24/7 Australian Support</span>
                </li>
                <li className="flex items-center">
                  <div className="w-4 h-4 bg-green-500 rounded-full mr-2" />
                  <span>Proactive Monitoring</span>
                </li>
                <li className="flex items-center">
                  <div className="w-4 h-4 bg-green-500 rounded-full mr-2" />
                  <span>Automated Scaling</span>
                </li>
              </ul>
            </div>
            <div className="bg-blue-50 p-6 rounded-lg hover:shadow-lg transition-shadow">
              <h3 className="font-semibold text-blue-800 mb-4">Financial Benefits</h3>
              <ul className="space-y-3">
                <li className="flex items-center">
                  <div className="w-4 h-4 bg-blue-500 rounded-full mr-2" />
                  <span>Predictable Monthly Costs</span>
                </li>
                <li className="flex items-center">
                  <div className="w-4 h-4 bg-blue-500 rounded-full mr-2" />
                  <span>Reduced Operational Overhead</span>
                </li>
                <li className="flex items-center">
                  <div className="w-4 h-4 bg-blue-500 rounded-full mr-2" />
                  <span>No Capital Investment</span>
                </li>
                <li className="flex items-center">
                  <div className="w-4 h-4 bg-blue-500 rounded-full mr-2" />
                  <span>Pay-as-you-grow Model</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Contact Section */}
        <div className="bg-gradient-to-r from-gray-800 to-gray-900 text-white p-12 rounded-lg text-center">
          <h2 className="text-3xl font-bold mb-6">Ready to Get Started?</h2>
          <p className="mb-8 text-lg">Contact us for a personalized assessment or build your custom quote now</p>
          <div className="flex flex-col md:flex-row justify-center space-y-4 md:space-y-0 md:space-x-6">
            <button 
              onClick={onGetQuote}
              className="px-8 py-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transform hover:scale-105 transition-all"
            >
              Build Custom Quote
            </button>
            <a 
              href="mailto:sales@uniware.com.au"
              className="px-8 py-4 border-2 border-white text-white rounded-lg hover:bg-white hover:text-gray-900 transform hover:scale-105 transition-all"
            >
              Contact Sales
            </a>
          </div>
          <div className="mt-8 space-y-2">
            <p className="font-semibold">1800 338 880</p>
            <p className="font-semibold">info@uniware.com.au</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SalesDeck;